import React, { Component } from 'react'

const UBER_EATS_URL = "https://www.ubereats.com/tw/store/doday-%E8%B1%86%E6%97%A5%E5%AD%90%E8%B1%86%E8%8A%B1%E7%94%9C%E5%93%81%E5%BA%97-%E6%9C%A8%E6%9F%B5%E5%89%B5%E5%A7%8B%E5%BA%97/1oM8GcEMR7GI2LwFmoKNyQ";
const FOODPANDA_URL = "https://www.foodpanda.com.tw/chain/cc3jt/dou-ri-zi-dou-hua-tian-pin-dian";
const DIRECT_ORDER_URL = "https://order.doday.com.tw";

class DeliveryButtons extends Component {
    render() {
        var variant = this.props.variant || 'default';

        if (variant === 'strip') {
            return (
                <div className="order_strip_buttons">
                    <a href={DIRECT_ORDER_URL} target="_blank" rel="noopener noreferrer" className="delivery_btn delivery_btn_primary">
                        官方線上訂餐
                    </a>
                    <a href={UBER_EATS_URL} target="_blank" rel="noopener noreferrer" className="delivery_btn delivery_btn_outline">
                        Uber Eats
                    </a>
                    <a href={FOODPANDA_URL} target="_blank" rel="noopener noreferrer" className="delivery_btn delivery_btn_outline">
                        Foodpanda
                    </a>
                </div>
            );
        }

        // Default variant — dark buttons for contact/order pages
        return (
            <div className="contact_delivery_grid">
                <a href={DIRECT_ORDER_URL} target="_blank" rel="noopener noreferrer" className="contact_delivery_card">
                    <div className="contact_delivery_card_icon">🛒</div>
                    <div className="contact_delivery_card_name">官方訂餐</div>
                </a>
                <a href={UBER_EATS_URL} target="_blank" rel="noopener noreferrer" className="contact_delivery_card">
                    <div className="contact_delivery_card_icon">🚗</div>
                    <div className="contact_delivery_card_name">Uber Eats</div>
                </a>
                <a href={FOODPANDA_URL} target="_blank" rel="noopener noreferrer" className="contact_delivery_card">
                    <div className="contact_delivery_card_icon">🐼</div>
                    <div className="contact_delivery_card_name">Foodpanda</div>
                </a>
            </div>
        );
    }
}

export default DeliveryButtons;
